import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { useModal } from '../../../../hooks/Modal';
import { ProfileCollectContext } from '../..';
import { ModalTitle, ModalText } from './styled';

export const ModalMaterialRejection = () => {
  const { closeModal, Modal } = useModal();

  const { protocolCollectCanceled } = useContext(ProfileCollectContext);

  const history = useHistory();

  const handleCloseModal = () => {
    closeModal();
    history.push('/acesso-rapido/tipo-de-coleta');
  };

  return (
    <Modal preventClose>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16
        }}
      >
        <ModalTitle>ATENÇÃO</ModalTitle>

        <ModalText>
          Pedido de Coleta Cancelado - Protocolo {protocolCollectCanceled}
        </ModalText>
        <ModalText>
          A Braspress agradece o seu contato e informa que pelo motivo da <br />
          encomenda se tratar de um produto incompatível, será necessário <br />
          entrar em contato com a filial responsável.
        </ModalText>
        <ModalText>
          Para consultar Regiões e contato, clique no link abaixo:
        </ModalText>

        <a
          target="_blank"
          rel="noreferrer"
          data-testid="openBranchLink"
          href={`${process.env.REACT_APP_URL_WEB}/acesso-rapido/nossas-filiais/`}
        >
          Clique aqui
        </a>

        <Button
          type="button"
          variant="contained"
          data-testid="okMaterialRejectionModalButton"
          onClick={handleCloseModal}
          style={{ padding: '6px 32px' }}
        >
          OK
        </Button>
      </Box>
    </Modal>
  );
};
